'use strict';

var leaflet = require('./leaflet');

require('./mapbox');

module.exports = leaflet;



//////////////////
// WEBPACK FOOTER
// ./~/mapbox.js/src/index.js
// module id = 835
// module chunks = 0